export const COMPANY_DEFAULT_FLOOD_PRODUCT_OPTION = { name: 'Company default', value: null };
